<template>
  <main class="d-flex flex-column min-vh-100">
    <HeaderComponent />
    <RouterView />
    <FooterComponent />
  </main>
</template>

<script setup>
import HeaderComponent from '../components/HeaderComponent.vue';
import FooterComponent from '../components/FooterComponent.vue';
</script>
